import React, { useState, useEffect } from 'react'
import { ImageForm } from './ImageForm'
import useChatImagePrompt from 'hooks/chat/useChatImagePrompt'
import CircularProgress from '@mui/material/CircularProgress'

export const MainImageForm: React.FC = () => {
  const apiUrl = 'https://your-api-url.com'

  const [chatResponse, setChatResponse] = useState<string>('')
  //const [loading, setLoading] = useState(false)
  const [submittedValue, setSubmittedValue] = useState<string>('')
  const [promptType, setPromptType] = useState<string>('')

  const label = 'Enter a description for an image to create:'
  const inputInstructions = 'Please type a phrase you would like to generate an image for.'

  const { result, loading, error } = useChatImagePrompt(submittedValue)

  useEffect(() => {
    //const { result, loading } = response
    setChatResponse(result || '')
    //setLoading(loading)
  }, [result])

  console.log('chatResponse: ', chatResponse)

  const handleSubmit = (value: string) => {
    setChatResponse('')
    setSubmittedValue(value)
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '4rem 0 4rem 0' }}>
        Enter a description of an image you would like created.
      </div>
      <ImageForm
        apiUrl={apiUrl}
        label={label}
        inputInstructions={inputInstructions}
        onSubmit={handleSubmit}
      />
      {loading && (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress />
        </div>
      )}
      {chatResponse && (
        <div>
          <h4>Chat Response</h4>
          <img src={chatResponse} />
        </div>
      )}
      {error && <div>An error has occured - please updated your prompt and try again.</div>}
    </div>
  )
}
